export const riskLevelOptions = {
  enter: false,
  height: "auto",
  calcHeight: 95,
  tip: false,
  stripe: true,
  searchShow: true,
  searchMenuSpan: 6,
  /** 表格搜索显隐按钮 */
  searchShowBtn: true,
  /** 是否启用功能按钮 */
  searchIcon: true,
  searchIndex: 0,
  tree: true,
  border: true,
  // index: true,
  // selection: true,
  addBtn: false,
  viewBtn: false,
  delBtn: false,
  editBtn: false,
  menuWidth: 150,
  dialogWidth: 880,
  dialogClickModal: false,
  column: [
    {
      label: "",
      prop: "my",
      hide: true,
      showColumn: false,
      search: true,
      display: false,
      menuClassName: "myClass",
      searchslot: true,
    },
    {
      label: "风险等级",
      prop: "level",
      minWidth: 100,
      align: "center",
      display: false,
      // 0-无风险 1-低风险 2-中风险 3-高风险
      dicData: [
        { label: "无风险", value: 0 },
        { label: "低风险", value: 1 },
        { label: "中风险", value: 2 },
        { label: "高风险", value: 3 }
      ]
    },
    // {
    //   label: "判定策略描述",
    //   prop: "dsDesc",
    //   width: 200,
    //   align: "center",
    //   display: false
    // },
    // {
    //   label: "判定状态",
    //   prop: "dsState",
    //   width: 200,
    //   display: false,
    //   align: "center",
    //   formatter: (val) => {
    //     return val.dsState == 1 ? '开' : '关'
    //   }
    // },
    {
      label: "执行策略",
      prop: "limitCode",
      minWidth: 300,
      align: "left",
      display: false
    },
    {
      label: "执行策略描述",
      prop: "limitName",
      minWidth: 300,
      align: "left",
      display: false
    },
    // {
    //   label: "执行状态",
    //   prop: "esState",
    //   width: 200,
    //   align: "center",
    //   display: false,
    //   formatter: (val) => {
    //     return val.esState == 1 ? '开' : '关'
    //   }
    // },
    {
      label: "创建时间",
      prop: "createTime",
      minWidth: 200,
      align: "center",
      display: false
    },
    {
      label: "更新时间",
      prop: "updateTime",
      minWidth: 200,
      align: "center",
      display: false
    }
    ,
    // {
    //   label: "备注",
    //   prop: "remark",
    //   minWidth: 300,
    //   align: "left",
    //   display: false
    // }
  ]
};

export const riskDeviceOptions = {
  addBtn: false,
  viewBtn: false,
  delBtn: false,
  editBtn: false,
  height: "auto",
  calcHeight: 80,
  index: true,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  selection: true,
  column: [
    {
      label: "渠道+设备UID",
      prop: "uid",
      width: 250,
      formatter: (val) => {
        return val.appid ? `(${val.appid}) ${val.uid}` : '-'
      }
    },
    {
      label: "MAC地址",
      prop: "mac",
      width: 200,
      align: "center",
    },
    {
      label: "AndroidID",
      prop: "androidId",
      width: 200,
      align: "center",
    },
    {
      label: "IDFA",
      prop: "idfa",
      width: 200,
      align: "center",
    },
    {
      label: "手机号",
      prop: "phone",
      width: 200,
      align: "center",
      display: false
    },
    {
      label: "风险等级",
      prop: "level",
      width: 200,
      align: "center",
      // 0-无风险 1-低风险 2-中风险 3-高风险
      dicData: [
        { label: "无风险", value: 0 },
        { label: "低风险", value: 1 },
        { label: "中风险", value: 2 },
        { label: "高风险", value: 3 }
      ]
    },
    {
      label: "执行策略",
      prop: "esName",
      width: 200,
      align: "left",
    },
    {
      label: "录入方式",
      prop: "enterType",
      width: 200,
      align: "center",
      display: false,
      formatter: (val) => {
        return val.enterType == 1 ? '自动录入' : '手动录入'
      }
    },
    {
      label: "录入时间",
      prop: "createTime",
      width: 200,
      align: "center",
      display: false
    },
    {
      label: "更新时间",
      prop: "updateTime",
      width: 200,
      align: "center",
      display: false
    },
    {
      label: "操作人",
      prop: "updateBy",
      width: 200,
      align: "center",
      display: false
    },
    {
      label: "备注说明",
      prop: "remark",
      width: 200,
      align: "left",
    }
  ]
}
